/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import {
    string, func,
} from 'prop-types';
import { TextField } from '@material-ui/core';
import { isEmpty } from '../../../../utils/object';

const ModifyGiftMessageMultiTextBox = ({
    setGiftMessage, giftMsg, isMobile, isCCOBrandEnabled
}) => {
    const giftMessageNoOfLines = isCCOBrandEnabled ? 4 : 3;
    const giftMessageCharPerLine =  30;
    const [form, setForm] = useState({});

    useEffect(() => {
        for (let i = 0; i < giftMessageNoOfLines; i += 1) {
            form[`giftMessage_${i}`] = '';
            if (giftMsg.length > 0) {
                const msgList = giftMsg.match(/.{1,30}/g);
                setForm((prevState) => ({
                    ...prevState,
                    [`giftMessage_${i}`]: msgList?.[i]?.length ? msgList[i] : '',
                }));
            }
        }
    }, []);

    useEffect(() => {
        let giftMessage = '';
        const giftMessageArray = Object.keys(form).map((msg) => form[msg]).filter((msg) => msg !== '');
        const isMultiLineMessageExist = (Array.isArray(giftMessageArray) && !isEmpty(giftMessageArray) && giftMessageArray.length > 1) || false;
        if (Array.isArray(giftMessageArray) && !isEmpty(giftMessageArray) && giftMessageArray.length === 1) giftMessage = giftMessageArray[0];
        else if (isMultiLineMessageExist) giftMessage = giftMessageArray.join('\n');
        setGiftMessage(giftMessage);
    }, [form]);

    const handleOnChangeMultiLine = (event) => {
        const { target: { name } } = event;
        let messageLine = event.target.value;
        let lastWord = '';
        let focusNextLine = false;
        // eslint-disable-next-line radix
        const positionToFocus = parseInt(name.replace('giftMessage_', '')) + 1;
        if (typeof document !== 'undefined'
            && positionToFocus < giftMessageNoOfLines && giftMessageCharPerLine
            && event.target.value.length >= giftMessageCharPerLine
            && document.getElementById(`giftMessage_${positionToFocus}`)
            && document.getElementById(`giftMessage_${positionToFocus}`).value.length === 0
        ) {
            focusNextLine = true;
            // Get the last word for set in the next line.
            if (event.target.value.length === giftMessageCharPerLine) {
               lastWord = messageLine.slice(messageLine.lastIndexOf(' ') + 1);
               messageLine = messageLine.substring(0, messageLine.lastIndexOf(' ') + 1); // Get the message line without last word
               if (messageLine === '') { // handle words that match charPerLine
                  messageLine = `${lastWord}`;
                  lastWord = '';
               } else {
                  const noOfLinesFound = lastWord.length;
                  const emptySpace = new Array(noOfLinesFound + 1).join(' ');
                  messageLine = `${messageLine}${emptySpace}`;
               }
            }
        }

        setForm((prevState) => ({
            ...prevState,
            [name]: event?.target?.value,
        }));

        if (focusNextLine) {
            const updateForm = { ...form };
            updateForm[`giftMessage_${positionToFocus - 1}`] = messageLine;
            updateForm[`giftMessage_${positionToFocus}`] = lastWord;
            document.getElementById(`giftMessage_${positionToFocus}`).focus();
            setForm(updateForm);
        }
    };

    const renderMultiTextBox = () => {
        const listOfTextBoxes = [];
        for (let i = 0; i < giftMessageNoOfLines; i += 1) {
            const giftMessageVal = form?.[`giftMessage_${i}`]?.includes('\n') ? form[`giftMessage_${i}`].replaceAll('\n', '') : form[`giftMessage_${i}`];
            listOfTextBoxes.push(
                <TextField
                    variant="outlined"
                    size="small"
                    id={`giftMessage_${i}`}
                    name={`giftMessage_${i}`}
                    onChange={handleOnChangeMultiLine}
                    value={giftMessageVal}
                    fullWidth={isMobile}
                    inputProps={{ maxLength: giftMessageCharPerLine }}
                    style={isMobile ? { marginBottom: '10px' } : { marginBottom: '10px', width: '51%' }}
                />,
            );
        }
        return listOfTextBoxes;
    };

    return renderMultiTextBox();
};

ModifyGiftMessageMultiTextBox.propTypes = {
    giftMsg: string.isRequired,
    setGiftMessage: func.isRequired,
};

export default ModifyGiftMessageMultiTextBox;
